import React from 'react';
import '../styles/botonIniciarJuego.css';

export default function BotonIniciarJuego(props) {
    return (
        <div className="iniciar--juego__div--container">
            <button onClick={() => props.funcionIniciarJuego(true)} class="iniciar--juego__btn--btn iniciar--juego__btn--rounded">
                <span class="iniciar--juego__span--text-green">{props.texto}</span>
            </button>
        </div>
    )
}
